import { TextField, styled } from '@mui/material';
import React, { useEffect, useState } from 'react';

interface IssueReportTextFieldProps {
    title: string;
    value?: string;
    shrink?: boolean;
    numsRows: number;
    onChange?: (value: string) => void;
}

const StyledTextField = styled(TextField)(({ theme }) => ({
    '& .MuiInputLabel-root': {
        color: theme.palette.primary.main,
    },
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.border.light,
        borderRadius: '10px',
    },
    '& .MuiInputBase-input': {
        color: theme.palette.primary.main,
    },
    '& .MuiOutlinedInput-root': {
        '& textarea': {
            overflow: 'hidden',
        },
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.border.main,
        borderWidth: '1px',
    },
    '& .MuiInputLabel-root.Mui-focused': {
        color: 'rgb(var(--color-foreground))!important',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.border.main,
        borderRadius: '10px',
    },
}));

const IssueReportTextField = (props: IssueReportTextFieldProps) => {
    const [shrink, setShrink] = useState(false);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (props.onChange) {
            props.onChange(e.target.value);
        }
    };

    useEffect(() => {
        if (props.shrink) setShrink(props.shrink);
    }, [props.shrink]);

    return (
        <StyledTextField
            label={props.title}
            value={props.value}
            onChange={handleChange}
            variant={'outlined'}
            multiline={true}
            rows={props.numsRows}
            fullWidth={true}
            type={'text'}
            onFocus={() => setShrink(true)}
            onBlur={(e) => setShrink(!!e.target.value)}
            InputLabelProps={{ shrink }}
        />
    );
};

export default IssueReportTextField;
